import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { QRCodeCanvas } from "qrcode.react";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Calendar } from "lucide-react";

/** Displays a big QR code for a coupon. `claim` shape:
 * { code, expires_at, discount_snapshot: {type, value}, post_title?, business_name? } */
export function QRCodeModal({ open, onOpenChange, claim }) {
    if (!claim) return null;
    const disc = claim.discount_snapshot || {};
    const discountLabel = disc.type === "FLAT" ? `₹${disc.value} OFF` : disc.type === "PERCENT" ? `${disc.value}% OFF` : null;
    const expiresText = claim.expires_at ? new Date(claim.expires_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md" data-testid="qr-modal">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-lg font-bold">
                        <Sparkles className="text-orange-500" size={20} />
                        Your coupon is ready
                    </DialogTitle>
                </DialogHeader>
                <div className="flex flex-col items-center gap-4 px-2 pb-2">
                    <div className="rounded-2xl border-4 border-orange-500 bg-white p-4" data-testid="qr-canvas-wrap">
                        <QRCodeCanvas
                            value={claim.code}
                            size={200}
                            fgColor="#0B0B0B"
                            bgColor="#FFFFFF"
                            level="M"
                            includeMargin={false}
                            data-testid="qr-canvas"
                        />
                    </div>
                    <div className="text-center">
                        <div className="font-mono text-2xl font-extrabold tracking-[0.15em] text-neutral-900" data-testid="qr-code-text">
                            {claim.code}
                        </div>
                        <div className="mt-1 text-xs text-neutral-500">Show this at the counter</div>
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-2">
                        {discountLabel && (
                            <Badge className="bg-orange-500 text-white" data-testid="qr-discount">{discountLabel}</Badge>
                        )}
                        {expiresText && (
                            <Badge variant="outline" className="text-xs">
                                <Calendar size={12} className="mr-1" /> Valid until {expiresText}
                            </Badge>
                        )}
                    </div>
                    {(claim.post_title || claim.business_name) && (
                        <div className="mt-1 max-w-[280px] text-center text-xs text-neutral-500">
                            {claim.business_name && <div className="font-semibold text-neutral-700">{claim.business_name}</div>}
                            {claim.post_title && <div className="truncate">{claim.post_title}</div>}
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default QRCodeModal;
